import { IGlobalConfigurationState } from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import { humanize } from '@app/utils/formatting'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap'
import {
  actionCreators,
  IPreferencesEditState,
} from '../modules/preferencesEdit'

type PreferencesModalProps = IPreferencesEditState &
  typeof actionCreators &
  IGlobalConfigurationState

export class PreferencesModal extends React.PureComponent<
  PreferencesModalProps
> {
  constructor(props: PreferencesModalProps) {
    super(props)
    bindFunctions(this)
  }

  public render() {
    if (
      !this.props.configuration ||
      !this.props.configuration.landingPageOptions
    ) {
      return <div />
    }
    return (
      <Modal
        centered
        isOpen={this.props.isOpen}
        onClosed={this._onModalClosed}
        onOpened={this._onModalOpened}
        toggle={this._closeModal}
      >
        <ModalHeader toggle={this._closeModal}>Preferences</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for='landingPage'>Landing Page</Label>
            <Input
              name='landingPage'
              onChange={this._onChangeLandingPage}
              required
              type='select'
              value={this.props.landingPage}
            >
              {this.props.configuration.landingPageOptions
                .toArray()
                .map((opt) => (
                  <option key={opt} value={opt}>
                    {humanize(opt)}
                  </option>
                ))}
            </Input>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color='secondary' onClick={this._closeModal} outline>
            <FontAwesomeIcon icon={['fal', 'times']} fixedWidth /> Cancel
          </Button>
          <Button
            color='primary'
            disabled={this.props.isSaving}
            onClick={this._updatePreferences}
          >
            <FontAwesomeIcon icon={['fal', 'save']} fixedWidth /> Update
            Preferences
          </Button>
        </ModalFooter>
      </Modal>
    )
  }

  private _closeModal() {
    this.props.closePreferencesModal()
  }

  private _onChangeLandingPage(event: React.ChangeEvent<HTMLInputElement>) {
    this.props.setLandingPage(event.target.value)
  }

  private _onModalClosed() {
    this.props.resetState()
  }

  private _onModalOpened() {
    this.props.loadPreferences()
  }

  private _updatePreferences() {
    this.props.updatePreferences(this.props.landingPage)
  }
}
